import FileFormatLink from "../../common/domain/FileFormatLink";
import {Config} from '../../config';

export const getActiveFileFormats = (config: Config) : Array<FileFormatLink> => {
    const fileFormats : Array<FileFormatLink> = [];
    
    if (config.bepActiveFlag) {
        fileFormats.push({
            id: 'Fixed Income Required Fields',
            path: '/field-spec/bonds',
        });
    }

    if (config.fepSpotActiveFlag) {
        fileFormats.push({
            id: 'FX Spot Required Fields',
            path: '/field-spec/spot',
        });
    }

    if (config.fepForwardsActiveFlag) {
        fileFormats.push({
            id: 'FX Forward Required Fields',
            path: '/field-spec/forwards',
        });
    }

    if (config.fepNonLinearActiveFlag) {
        fileFormats.push({
            id: 'Options Required Fields',
            path: '/field-spec/options',
        });    
    }

    if (config.repLinearActiveFlag) {
        fileFormats.push({
            id: 'Interest Rate Swap Required Fields',
            path: '/field-spec/irs',
        });
    }
    
    return fileFormats;
}